import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";

const INDIA_SAFFRON = "#FF9933";
const INDIA_GREEN = "#138808";

const PrivacyPolicy = () => {
    const { language } = useLanguage();

    const isMarathi = language === "mr";

    return (
        <Box sx={{ py: 6, backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
            <Container maxWidth="md">
                {/* Title */}
                <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                            color: "#1e293b",
                            position: "relative",
                            display: "inline-block",
                            "&:after": {
                                content: '""',
                                position: "absolute",
                                bottom: -8,
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: { xs: 60, sm: 80 },
                                height: 3,
                                background: `linear-gradient(90deg, ${INDIA_SAFFRON}, ${INDIA_GREEN})`,
                                borderRadius: 2,
                            },
                        }}
                    >
                        {isMarathi ? "गोपनीयता धोरण" : "Privacy Policy"}
                    </Typography>
                </Box>

                {/* Intro */}
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "आपत्ती व्यवस्थापन विभागात आम्ही तुमच्या गोपनीयतेचे संरक्षण करण्यास आणि तुमच्या वैयक्तिक माहितीची सुरक्षितता सुनिश्चित करण्यास कटिबद्ध आहोत. हे गोपनीयता धोरण आम्ही तुमच्याकडून गोळा केलेली माहिती आपत्ती व्यवस्थापन सेवांच्या संदर्भात कशी गोळा करतो, वापरतो आणि सुरक्षित ठेवतो याची रूपरेषा सांगते. कृपया तुमच्या वैयक्तिक माहितीसंबंधी आमच्या पद्धती समजून घेण्यासाठी हे धोरण काळजीपूर्वक वाचा."
                        : `At Disaster Management, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard the data you provide to us in the context of our disaster management services. Please read this policy carefully to understand our practices regarding your personal information.`}
                </Typography>

                {/* Information Collection */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "माहिती संकलन:" : "Information Collection:"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "आपत्ती व्यवस्थापन क्रियांमध्ये सहभागी असलेल्या व्यक्ती किंवा संस्थांकडून आम्ही वैयक्तिक माहिती गोळा करू शकतो. या माहितीत खालील गोष्टींचा समावेश असू शकतो, परंतु त्यापुरते मर्यादित नाही: नावे, संपर्क तपशील आणि पत्ते, लोकसंख्याशास्त्रीय माहिती, आपत्कालीन संपर्क माहिती आणि आपत्ती व्यवस्थापन सेवा पुरविण्यासाठी आवश्यक इतर कोणतीही माहिती."
                        : `We may collect personal information from individuals or organizations involved in disaster management activities. This information may include, but is not limited to: Names, contact details, and addresses Demographic information Emergency contact information Any other data necessary for providing disaster management services`}
                </Typography>

                {/* Use of Information */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "माहितीचा वापर:" : "Use of Information:"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "संकलित माहितीचा वापर आम्ही खालील उद्दिष्टांसाठी करतो: आपत्ती प्रतिसाद आणि पुनर्प्राप्ती प्रयत्न सुलभ करणे आणि समन्वय करणे, आपत्ती व्यवस्थापनात सहभागी व्यक्ती किंवा संस्थांशी संवाद साधणे, आपत्ती घटनांबाबत संबंधित अद्यतने, सूचना आणि अलर्ट प्रदान करणे, आमच्या आपत्ती व्यवस्थापन सेवांमध्ये सुधारणा करण्यासाठी संशोधन आणि विश्लेषण करणे, तसेच कायदेशीर आणि नियामक आवश्यकतांचे पालन करणे."
                        : `We use the collected information to: Facilitate and coordinate disaster response and recovery efforts Communicate with individuals or organizations involved in disaster management Provide relevant updates, alerts, and notifications regarding disaster events Conduct research and analysis to improve our disaster management services Comply with legal and regulatory requirements`}
                </Typography>

                {/* Data Sharing */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "डेटा शेअरिंग:" : "Data Sharing:"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "आम्ही खालील परिस्थितींमध्ये तुमची वैयक्तिक माहिती शेअर करू शकतो: आपत्ती व्यवस्थापन क्रियांमध्ये सहभागी संबंधित शासकीय संस्था, आपत्कालीन सेवा आणि अधिकृत भागीदारांसोबत; आमच्या सेवा पुरविण्यात मदत करणाऱ्या विश्वासार्ह तृतीय-पक्ष सेवा प्रदात्यांसोबत (कडक गोपनीयतेच्या अटींच्या अधीन); तसेच कायद्याने आवश्यक असल्यास किंवा आमचे अधिकार, मालमत्ता किंवा सुरक्षितता किंवा इतरांच्या अधिकार, मालमत्ता किंवा सुरक्षिततेचे संरक्षण करण्यासाठी."
                        : `We may share your personal information in the following circumstances:
With relevant government agencies, emergency services, and authorized partners involved in disaster management activities With trusted third-party service providers who assist us in delivering our services (subject to strict confidentiality obligations) When required by law or to protect our rights, property, or safety, or the rights, property, or safety of others`}
                </Typography>

                {/* Data Security */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "डेटा सुरक्षा:" : "Data Security:"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "तुमची वैयक्तिक माहिती अनधिकृत प्रवेश, बदल किंवा प्रकटीकरणापासून सुरक्षित ठेवण्यासाठी आम्ही उद्योग-मानक सुरक्षा उपायांचा वापर करतो. तथापि, कृपया लक्षात घ्या की इंटरनेटवरील प्रसारण किंवा इलेक्ट्रॉनिक संचयनाची कोणतीही पद्धत पूर्णपणे सुरक्षित नसते आणि आम्ही पूर्ण सुरक्षिततेची हमी देऊ शकत नाही."
                        : `We employ industry-standard security measures to protect your personal information from unauthorized access, alteration, or disclosure. However, please note that no method of transmission over the internet or electronic storage is entirely secure, and we cannot guarantee absolute security.`}
                </Typography>

                {/* Data Retention */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "डेटा साठवण:" : "Data Retention:"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "ज्या उद्देशांसाठी माहिती गोळा करण्यात आली आहे ते पूर्ण करण्यासाठी आणि लागू कायदे व नियमांचे पालन करण्यासाठी आवश्यक तेवढ्या कालावधीपर्यंतच आम्ही तुमची वैयक्तिक माहिती जतन करून ठेवू."
                        : `We will retain your personal information only for as long as necessary to fulfill the purposes for which it was collected and to comply with applicable laws and regulations.`}
                </Typography>

                {/* Your Rights */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "तुमचे अधिकार:" : "Your Rights:"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "तुम्हाला आमच्याकडे असलेल्या तुमच्या वैयक्तिक माहितीवर प्रवेश करण्याचा, ती दुरुस्त करण्याचा किंवा हटवण्याचा अधिकार आहे. तुम्हाला या अधिकारांचा वापर करायचा असल्यास किंवा तुमच्या डेटासंबंधी काही चिंता असल्यास, कृपया खाली दिलेल्या 'Contact Us' विभागातील माहितीद्वारे आमच्याशी संपर्क साधा."
                        : `You have the right to access, correct, or delete your personal information held by us. If you wish to exercise any of these rights or have any concerns regarding your data, please contact us using the information provided in the "Contact Us" section below.`}
                </Typography>

                {/* Updates */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "गोपनीयता धोरणातील अद्यतने:" : "Updates to Privacy Policy:"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "आमच्या पद्धतींमध्ये किंवा कायदेशीर जबाबदाऱ्यांमध्ये बदल दर्शविण्यासाठी आम्ही वेळोवेळी या गोपनीयता धोरणात अद्यतने करू शकतो. कोणत्याही अद्यतनांसाठी हे धोरण वेळोवेळी तपासण्यास आम्ही तुम्हाला प्रोत्साहित करतो."
                        : `We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. We encourage you to review this policy periodically for any updates.`}
                </Typography>

                {/* Contact */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "संपर्क करा:" : "Contact Us:"}
                </Typography>
                <Typography variant="body1">
                    {isMarathi
                        ? "या गोपनीयता धोरणासंबंधी किंवा आमच्या डेटा पद्धतींबाबत काही प्रश्न, चिंता किंवा विनंत्या असल्यास कृपया Contact Us पृष्ठावर दिलेल्या अधिकृत संपर्क तपशीलांवर आम्हाला मेल करा किंवा कॉल करा."
                        : `If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, Please Mail and call us at official contact details given on the contact us page.`}
                </Typography>
            </Container>
        </Box>
    );
};

export default PrivacyPolicy;
